export default "__VITE_ASSET__BTinvOCl__"